import React from 'react';
import { 
  Leaf, Mountain, PenTool, Droplets, 
  Waves, Building2, Home, Wrench 
} from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  Leaf, Mountain, PenTool, Droplets,
  Waves, Building2, Home, Wrench
};

const Services = () => {
  return (
    <section id="services" className="services-section" aria-label="Our Landscaping Services">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">What We Offer</span>
          <h2 className="section-title">Comprehensive Landscaping Services</h2>
          <p className="section-description">
            From concept to completion, we deliver sustainable landscape solutions 
            that thrive in the UAE's unique climate
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div 
                key={service.id} 
                className="service-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="service-icon-wrapper">
                  <div className="service-icon-bg"></div>
                  <Icon className="service-icon" />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-hover-line"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
